import {BaseSyntheticEvent} from 'react';

import {ActionPlanImpactLevel, CategoryKeyEnum, Maybe} from '#apollo/schema';
import {Checkbox, Icon, Text} from '#component/base';
import {ActionPlanPage} from '#component/page/ActionPlan/ActionPlan.types';
import {ImpactTag} from '#component/page/ActionPlan/components/ImpactTag';
import {useViewportSize} from '#hook';
import {sprinkles} from '#style/sprinkles';
import {getCategoryIconName} from '#util';

import {CategoryNameMap} from './RecommendationRow.util';

import * as css from './RecommendationRow.css';

export interface RecommendationRowProps {
  categoryKey: CategoryKeyEnum;
  id: string;
  impactLevel?: ActionPlanImpactLevel | null;
  recommended?: boolean;
  selected?: boolean;
  recommendedResponse?: string;
  healthFactorAssessment?: ActionPlanPage.HealthFactorAssessment | null;
  onChange: (e: BaseSyntheticEvent) => void;
  onClick: (e?: BaseSyntheticEvent) => void;
  onClickLearnWhy(e?: BaseSyntheticEvent): void;
}
export const RecommendationRow = ({
  recommended = false,
  selected = false,
  impactLevel = ActionPlanImpactLevel.Low,
  recommendedResponse,
  healthFactorAssessment,
  onClick,
  onClickLearnWhy,
  onChange,
}: RecommendationRowProps) => {
  const {isDesktop} = useViewportSize();
  const {key: categoryKey} = healthFactorAssessment?.categoryAssessment?.category ?? {
    key: CategoryKeyEnum.Research,
  };

  const handleCheckboxChange = (e: BaseSyntheticEvent) => {
    if (!isDesktop) return;
    e.stopPropagation();
    onChange(e);
  };

  return (
    <tr className={css.root({selected})} onClick={onClick}>
      <Text as="td" className={css.cell} color="mineShaft" fontWeight="semiBold">
        <div className={sprinkles({content: 'between', flex: 'flex', gap: 8, items: 'center'})}>
          <div className={sprinkles({flex: 'flex', gap: [16, 24], items: 'center'})}>
            <Checkbox
              checked={selected}
              className={sprinkles({overflow: 'hidden', shrink: 0})}
              onChange={handleCheckboxChange}
              readOnly={!isDesktop}
            />
            {recommendedResponse}
          </div>
        </div>
      </Text>

      {isDesktop && (
        <Text as="td" className={css.cell} color="mineShaft">
          <div
            className={sprinkles({
              flex: 'flex',
              gap: [8, 16, 24],
              items: 'center',
              content: 'start',
            })}>
            <Icon color="doveGray" name={getCategoryIconName(categoryKey)} />
            {CategoryNameMap[categoryKey]}
          </div>
        </Text>
      )}

      <Text as="td" className={css.cell} color="mineShaft">
        <div className={sprinkles({flex: 'flex', gap: 8, items: 'center', content: 'center'})}>
          <ImpactTag impactLevel={impactLevel as unknown as Maybe<ActionPlanImpactLevel>} />
        </div>
      </Text>

      {isDesktop && (
        <Text as="td" className={css.cell}>
          <button
            onClick={onClickLearnWhy}
            className={sprinkles({
              flex: 'flex',
              content: 'center',
            })}>
            <Icon name="BookBookmark" color="burgundy" />
          </button>
        </Text>
      )}
    </tr>
  );
};
